import React, { useEffect, useState } from "react";
import { Input, LabelText, Text, FlexContainer, InputWrapper, PH3Text } from "../../design";
import { INDIAN_STATES, USA_STATES } from "../../appconstants";
import { Controller } from "react-hook-form";
import NumberFormat from "react-number-format";
import Select from "react-select";
import { ErrorMessage } from "@hookform/error-message";

const postalCodes = require('postal-codes-js');

type Props = {
  control: any,
  errors: any,
  alpha2: String,
  billStatesList: Array,
  isBillingAdressRequired: Boolean,
  defaultCountry: Any,
  countryNameCode: String,
}

const Address = (props: Props) => {
  const { control, errors, alpha2, billStatesList, defaultCountry, countryNameCode, isBillingAdressRequired } = props;
  const [postalCode, setPostalCode] = useState('Area Pincode');
  const [maxLength, setMaxLength] = useState(5);
  const [pincodeLabel, setPincodeLabel] = useState('Pincode');

  const isZipcodeValidate1 = (data: string) => {
    const cuntryCode = countryNameCode || (defaultCountry && defaultCountry.code);
    if (postalCodes.validate(cuntryCode, data) !== true) {
      return postalCodes.validate(cuntryCode, data)
    }
  };

  useEffect(() => {
    if (alpha2 === 'IN') {
      setPostalCode('Area Pincode');
      setMaxLength(6);
      setPincodeLabel('Pincode');
    } else if (alpha2 === 'US') {
      setPostalCode('Area Zipcode');
      setMaxLength(5);
      setPincodeLabel('Zipcode');
    } else {
      setPostalCode('Area Zipcode');
      setMaxLength(5);
      setPincodeLabel('Zipcode');
    }
  }, [alpha2]);

  // const customStyles = {
  //   control: base => ({
  //     ...base,
  //     height: 33,
  //     minHeight: 33,
  //     marginTop: "0px",
  //     marginBottom: "0px",
  //     width: "268px",
  //     border: "none",
  //   }),
  //   dropdownIndicator: base => ({
  //     ...base,
  //     height: 33,
  //     minHeight: 33,
  //     border: "none",
  //   })
  // };

  const customStyles = {
    container: base => ({
      ...base,
      width: '100%',
      height: '41px',
      // marginTop: '8px',
      marginBottom: '8px',
      borderRadius: '10px',
    }),
    control: base => ({
      ...base,
      height: '41px',
      minHeight: '41px',
      border: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important',
      marginTop: '8px',
      width: '100%'
    }),
    dropdownIndicator: base => ({
      ...base,
      height: 33,
      minHeight: 33,
    })
  };

  const customInputStyle = {
    background: 'white',
    // color: 'black',
    borderColor: '#CCCCCC',
    width: '100%',
    height: '41px',
    paddingLeft: '15px',
  }

  const customLabelStyle = {
    color: 'black'
  };

  const customContainerStyle = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    border: 'none',
    borderRadius: '5px',
    // marginTop: '8px',
    // marginBottom: '8px',
    width: '100%',
  }

  const customRowFlexContainerProps = {
    xs: '100%',
    md: '100%',
    gap: '5%',
  };

  const customColFlexContainerProps = {
    xs: '100%',
    flexDirection: 'col',
  };

  return (
    <>
      <FlexContainer>
        <FlexContainer {...customRowFlexContainerProps}>
          <PH3Text className="my-3 mx-0 p-0" fontWeight="bold">ADDRESS DETAILS</PH3Text>
        </FlexContainer>
        <FlexContainer {...customRowFlexContainerProps}>
          <FlexContainer {...customColFlexContainerProps} md="63.3%">
            <LabelText style={customLabelStyle}>Address <span style={{ color: 'red' }}>*</span></LabelText>
            <Controller
              defaultValue={''}
              // marginBottom="0px"
              // marginTop="8px"
              // borderDown="none"
              // borderRadius="4px 4px 0px 0px"
              control={control}
              name="address"
              placeholder="Street Address"
              rules={{
                required: 'Street Address is required'
              }}
              color={errors.address ? "red" : "inherit"}
              as={<Input style={customInputStyle}/>}
            />
            <ErrorMessage
              errors={errors}
              name="address"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
          </FlexContainer>
          <FlexContainer {...customColFlexContainerProps} md="31.6%">
            <LabelText style={customLabelStyle}>City <span style={{ color: 'red' }}>*</span></LabelText>
            <Controller
              defaultValue={""}
              color={errors.city ? "red" : "inherit"}
              marginBottom="0px"
              control={control}
              name="city"
              placeholder="City"
              rules={{
                required: 'City is required'
              }}
              as={<Input
                style={customInputStyle}
              />}
            />
            <ErrorMessage
              errors={errors}
              name="city"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
          </FlexContainer>
        </FlexContainer>
        <FlexContainer {...customRowFlexContainerProps}>
          <FlexContainer {...customColFlexContainerProps} md="47.5%">
            <LabelText style={customLabelStyle}>State <span style={{ color: 'red' }}>*</span></LabelText>
            <InputWrapper 
              // marginTop="8px" 
              // width='299px' 
              // borderDown="none !important" 
              // paddingRight='5px' 
              // borderRadius="4px 4px 0px 0px"
              style={customContainerStyle}
            >
              {
                isBillingAdressRequired ? (
                  <Controller
                    defaultValue={""}
                    color={errors.state ? "red" : "inherit"}
                    marginBottom="0px"
                    marginTop="8px"
                    border="0px !important"
                    control={control}
                    name="state"
                    placeholder="Select state"
                    rules={{
                      required: 'State is required'
                    }}
                    as={<Select
                      // theme={theme => ({
                      //   ...theme,
                      //   borderRadius: "4px 0 0 4px",
                      //   boxShadow: 0,
                      // })}
                      // menuIsOpen={true}
                      menuPlacement="auto"
                      styles={customStyles}
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.isoCode}
                      options={billStatesList} />}
                  />
                ) : (
                  <Controller
                    defaultValue={""}
                    color={errors.state ? "red" : "inherit"}
                    // marginBottom="0px"
                    // marginTop="8px"
                    // border="0px !important"
                    control={control}
                    name="state"
                    placeholder="Select state"
                    rules={{
                      required: 'State is required'
                    }}
                    as={<Select
                      // theme={theme => ({
                      //   ...theme,
                      //   borderRadius: "4px 0 0 4px",
                      //   boxShadow: 0,
                      // })}
                      // menuIsOpen={true}
                      menuPlacement="auto"
                      styles={customStyles}
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.code}
                      options={alpha2 === "IN" ? INDIAN_STATES : USA_STATES} />}
                  />
                )
              }
            </InputWrapper>
            <ErrorMessage
              errors={errors}
              name="state"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
          </FlexContainer>
          <FlexContainer {...customColFlexContainerProps} md="47.5%">
            <LabelText style={customLabelStyle}>{postalCode} <span style={{ color: 'red' }}>*</span></LabelText>
            {
              isBillingAdressRequired ? (
                <Controller
                  defaultValue={""}
                  color={errors.postalCode ? "red" : "inherit"}
                  // marginBottom="0px"
                  control={control}
                  name="postalCode"
                  placeholder={postalCode}
                  rules={{
                    required: `${pincodeLabel} is required`,
                    validate: isZipcodeValidate1
                  }}
                  as={<Input
                    type="text"
                    name="postalCode"
                    placeholder="Enter your card number"
                    style={customInputStyle}
                  />}
                  customInput={Input}
                />
              ) : (
                <Controller
                  defaultValue={""}
                  color={errors.postalCode ? "red" : "inherit"}
                  // marginBottom="0px"
                  control={control}
                  name="postalCode"
                  placeholder={postalCode}                  
                  rules={{
                    required: `${pincodeLabel} is required`,
                    minLength: { value: 5, message: `Postal code must be ${maxLength} characters` }
                  }}
                  as={
                      <NumberFormat 
                        minLength={5} 
                        maxLength={maxLength} 
                        allowNegative={false} 
                        decimalScale={0}
                        style={customInputStyle} 
                      />
                    }
                  customInput={Input}
                />
              )
            }
            <ErrorMessage
              errors={errors}
              name="postalCode"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
    </>
  )
};


export default Address;
